export { default as HomePage } from './HomePage';


// WEBPACK FOOTER //
// ./src/screens/HomePage/index.js